import styled, { css } from 'styled-components';

export const SearchBarContainer = styled.div<{ sidebarVersion: boolean }>`
  height: 6.5rem;
  max-width: 750px;
  width: 100%;
  margin: 0 auto;

  form {
    height: 100%;
    width: 100%;
    background-color: #fff;
    border-radius: 5px;

    display: flex;
    align-items: center;
  }

  button {
    background-color: transparent;
    padding: 0 2.4rem;
    border-radius: 5px;
    color: ${({ theme }) => theme.color.primary};
    height: 100%;
  }

  input {
    flex: 1;
    border: 0;
    border-radius: 5px;
    height: 100%;

    font-size: 1.6rem;
    line-height: 2.4rem;
  }

  @media (max-width: 640px) {
    height: 4.8rem;

    button {
      padding: 0 1.6rem;
    }

    input {
      font-size: 1.3rem;
      line-height: 1.95rem;
    }
  }

  ${({ sidebarVersion }) =>
    sidebarVersion &&
    css`
      height: 4.8rem;

      button {
        padding: 0 1.6rem;
      }

      input {
        font-size: 1.3rem;
        line-height: 1.95rem;
      }
    `}
`;
